import { apiClient } from '../axiosInstance';
import { ENDPOINTS } from '../endpoints';
import type { Customer } from '../../types/customer';
import type { AuthService } from './interfaces/AuthService';

export const authService: AuthService = {
  async login(email, password) {
    const { data } = await apiClient.post<Customer>(ENDPOINTS.v1.users.signIn, {
      email,
      password,
    });
    return data;
  },

  signOut(): Promise<void> {
    return apiClient.delete(ENDPOINTS.v1.users.signOut).then(() => undefined);
  },

  async findByEmail(email) {
    const { data } = await apiClient.get<Customer>(
      ENDPOINTS.v1.users.findByEmail,
      { params: { email } },
    );
    return data;
  },

  async forgotPassword(email) {
    await apiClient.post(ENDPOINTS.v1.users.forgotPassword, { email });
  },

  async resetPassword(token, customerId, password, passwordConfirmation) {
    await apiClient.post(ENDPOINTS.v2.customers.resetPassword(customerId), {
      token,
      password,
      password_confirmation: passwordConfirmation,
    });
  },
};
